import styled from 'styled-components';
import { Select } from 'antd';

const PrimarySelect = styled(Select)`
  .ant-select-selection-item {
    color: #0046ff;
    font-size: 16px;
  }
`;

export default PrimarySelect;
